import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DocumentosAuditoriaService } from '../services/documentos-auditoria.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentosAuditoriaGuard implements CanActivate {
  constructor(public _documentosAuditoriaService: DocumentosAuditoriaService,
    public router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {



    let p = new Promise<boolean>((resolve, reject) => {

      let url = state.url;
      let params = route.queryParams;

      let idContratista = params.c;
      let token = params.t;

      // Valaidar que la ruta sea válida
      if (typeof idContratista === 'undefined'
        || typeof token === 'undefined') {
        alert('Ruta inválida');
        this.router.navigate(['/pagenotfound']);
        return false;
      }
      this._documentosAuditoriaService.validarTokenSolicitud(idContratista, token)
        .subscribe((resp: any) => {

          let { datos } = resp;

          if (datos.length > 0) {

            // Validar el estatus de la solicitud de documentos
            if (datos[0].estatus === 1 || datos[0].estatus === 4) {

              return resolve(true);

            } else {

              alert(`   
                    Token incorrecto o expirado. `);
              this.router.navigate(['/pagenotfound']);
              return reject(false);

            }
          }
          else {
            alert(`   
      Token incorrecto o expirado. 
      Favor de revisar en su correo electrónico si existe un nuevo link o 
      solicite uno nuevo en el área de auditoría.`);
            this.router.navigate(['/pagenotfound']);
            return reject(false);
          }
        }, error => {
          console.log(error)
          alert('Ocurrió un problema');
          this.router.navigate(['/pagenotfound']);
          return reject(false);
        });

    });
    return p;
  }
}
